import { render, staticRenderFns } from "./BanksAccounts.vue?vue&type=template&id=fa5a6128"
import script from "./BanksAccounts.vue?vue&type=script&lang=js"
export * from "./BanksAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports